export const TESTIMONIALS_2_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Testimonial Cards (Video Section, no blur effect for image in variant 2. Prefer using an image with all icons or texts in it for variant 2. You will have more control over the design)",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_quote_icon: "",
    meta_alt_icon_image: "Quote icon",
    meta_alt_icon: "Quote icon",
    meta_name: "",
    meta_name_text_color: "#FFFFFF",
    meta_designation: "",
    meta_designation_text_color: "#FFFFFF",
    meta_description: "",
    meta_description_text_color: "#FFFFFF",
    meta_text_block_color: "rgba(150,4,25,0.14)",
    meta_placed_at_text: "placed at",
    meta_placed_at_text_color: "#FFFFFF",
    meta_logo: "",
    meta_student_image: "",
    meta_student_image_alt: "student image",
    meta_student_mobile_image: "",
    meta_student_mobile_image_alt: "student image",
    meta_video_link: "",
    meta_priority: 1,
    meta_status: true,
  },

  TESTIMONIALS_FIELDS_CONFIG: [
    {
      fieldName: "layout_variant",
      label: "Layout Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Layout Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1 (Default)", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title (max 20 characters)",
      value: "Hear From Those ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 20 characters",
      required: false,
      defaultValue: "Hear From Those ",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pre title color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title (max 20 characters)",
      value: "Who've Been There",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 20 characters",
      required: false,
      defaultValue: "Who've Been There",
    },
    {
      fieldName: "title_start_color",
      label: "Title Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title gradient start color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_end_color",
      label: "Title Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title gradient end color (optional)",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg)",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "scroll_frequency",
      label: "Scroll Frequency",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter scroll frequency in ms (e.g., 3000). Leave empty to disable auto-scroll.",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Left Arrow Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Left Navigation Icon Alt Text",
      value: "Previous",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left navigation icon",
      required: false,
      defaultValue: "Previous",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Right Arrow Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Right Navigation Icon Alt Text",
      value: "Next",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right navigation icon",
      required: false,
      defaultValue: "Next",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button background color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_icon",
      label: "Button Icon",
      filedType: "FILE",
      value: "",
      valueType: "string",
      placeholder: "Button icon with text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Scroll reveal on section content",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Quote Icon",
      fieldName: "meta_quote_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Quote Icon (Mandatory)",
      required: true,
      defaultValue: "",
    },
    {
      header: "Quote Icon Alt Text",
      fieldName: "meta_alt_icon_image",
      value: "Quote icon",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for quote icon",
      required: false,
      defaultValue: "Quote icon",
    },
    {
      header: "Name (max 25 characters)",
      fieldName: "meta_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 25 characters",
      required: false,
      defaultValue: "",
    },
    {
      header: "Name Text Color",
      fieldName: "meta_name_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter name text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Batch / designation (max 25 characters)",
      fieldName: "meta_designation",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 25 characters",
      required: false,
      defaultValue: "",
    },
    {
      header: "Designation Text Color",
      fieldName: "meta_designation_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter designation text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Card description (max 130 characters)",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Max 130 characters",
      required: false,
      defaultValue: "",
    },
    {
      header: "Description Text Color",
      fieldName: "meta_description_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Text Block / Quote Panel Color (Variant 2)",
      fieldName: "meta_text_block_color",
      value: "rgba(150,4,25,0.14)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Quote panel background color",
      required: false,
      defaultValue: "rgba(150,4,25,0.14)",
    },
    {
      header: "Placed At Text",
      fieldName: "meta_placed_at_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Placed At Text (max 1 line)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Placed At Text Color",
      fieldName: "meta_placed_at_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter placed at text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Logo",
      fieldName: "meta_logo",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Placed At Logo (max 1)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Alt Logo",
      fieldName: "meta_alt_icon",
      value: "Quote icon",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for icon",
      required: false,
      defaultValue: "Quote icon",
    },
    {
      header: "Student Image",
      fieldName: "meta_student_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Student Image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Student Image Alt Text",
      fieldName: "meta_student_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter student image alt text",
      required: false,
      defaultValue: "",
    },
    {
      header: "Student Mobile Image",
      fieldName: "meta_student_mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Student Mobile Image (falls back to desktop image if empty)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Student Mobile Image Alt Text",
      fieldName: "meta_student_mobile_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile student image alt text",
      required: false,
      defaultValue: "",
    },
    {
      header: "Video link (YouTube)",
      fieldName: "meta_video_link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "Optional — full YouTube URL (watch, youtu.be, or embed). Shows a play button on the student image.",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show this card",
      defaultValue: true,
    },
  ],
};
